module.exports = __webpack_public_path__ + "static/p-83e25ca8df2bd0183b0f97d1a26f39cf.jpg";